<template>
  <!-- 预警设置 -->
  <div class="app-container">
    <el-form :inline="true" ref="addFormS" :model="addFormS" class="demo-form-inline jiaoyan" label-width="150px" size="mini">
      <div style="display: flex; justify-content: space-between;">
        <div class="addressBox" style="margin-top:20px;width:48%; ">
          <h4 class="title">
            <span><i class="fa fa-user-circle-o iconFont" aria-hidden="true"></i>授信贷款预警提醒设置：</span>
          </h4>
          <div style="margin-left:20px">
            <div>
              <el-form-item label="授信到期提醒:" :prop="'creditDateReminder.itemNo'" :rules="requiredRule" class="jiage" >
                <el-radio-group v-model="addFormS.creditDateReminder.itemNo">
                  <el-radio-button label="1">开</el-radio-button>
                  <el-radio-button label="2">关</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="" :prop="'creditDateReminder.showName'" :rules="rulesS.creditDateReminder" class="jiage" v-if="addFormS.creditDateReminder.itemNo=='1'" >
                <el-input placeholder="" maxlength="5" v-number-input.float="0" v-model.trim="addFormS.creditDateReminder.showName"></el-input>
                <span class="danwei">天</span>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="授信额度剩余:" :prop="'creditLimitReminder.itemNo'" :rules="requiredRule" class="jiage" >
                <el-radio-group v-model="addFormS.creditLimitReminder.itemNo">
                  <el-radio-button label="1">开</el-radio-button>
                  <el-radio-button label="2">关</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="" :prop="'creditLimitReminder.showName'" :rules="rulesS.creditLimitReminder" class="jiage" v-if="addFormS.creditLimitReminder.itemNo=='1'">
                <el-input placeholder="" maxlength="5" v-number-input.float="0" v-model.trim="addFormS.creditLimitReminder.showName"></el-input>
                <span class="danwei">万元</span>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="还款到期提醒:" :prop="'repaymentDateReminder.itemNo'" :rules="requiredRule" class="jiage" >
                <el-radio-group v-model="addFormS.repaymentDateReminder.itemNo">
                  <el-radio-button label="1">开</el-radio-button>
                  <el-radio-button label="2">关</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="" :prop="'repaymentDateReminder.showName'" :rules="rulesS.repaymentDateReminder" class="jiage" v-if="addFormS.repaymentDateReminder.itemNo=='1'">
                <el-input placeholder="" maxlength="5" v-number-input.float="0" v-model.trim="addFormS.repaymentDateReminder.showName"></el-input>
                <span class="danwei">天</span>
              </el-form-item>
            </div>
          </div>
        </div>
      </div>
    </el-form>
    <div class="footerBtn" style="width: 300px; display: flex; justify-content: flex-end;">
      <el-button type="primary" class="bigBtn" @click="saveFnS">保存</el-button>
    </div>
  </div>
</template>

<script>
import { getWarningReminderSet, updateWarningReminderSet } from '@/api/common-signature'

const requiredRule = [{ required: true, message: '请选择', trigger: 'change' }]

export default {
  data () {
    // 开状态下，对应 showName 必填
    const showNameRule = (group) => [{
      validator: (rule, value, callback) => {
        if (this.addFormS[group].itemNo === '1' && (value === '' || value === undefined || value === null)) {
          callback(new Error('请输入数值'))
        } else {
          callback()
        }
      },
      trigger: 'blur'
    }]
    return {
      addFormS: {
        creditDateReminder: { itemNo: '2', showName: '' },
        creditLimitReminder: { itemNo: '2', showName: '' },
        repaymentDateReminder: { itemNo: '2', showName: '' }
      },
      requiredRule,
      rulesS: {
        creditDateReminder: showNameRule('creditDateReminder'),
        creditLimitReminder: showNameRule('creditLimitReminder'),
        repaymentDateReminder: showNameRule('repaymentDateReminder')
      }
    }
  },
  created () {
    this.getDetail()
  },
  methods: {
    getDetail () {
      getWarningReminderSet().then(res => {
        const data = res.data || res || {}
        // 直接拿接口返回的三组对象整体赋值，仅做轻量兜底（缺失时给默认/统一字符串类型）
        this.addFormS = {
          creditDateReminder: this.norm(data.creditDateReminder),
          creditLimitReminder: this.norm(data.creditLimitReminder),
          repaymentDateReminder: this.norm(data.repaymentDateReminder)
        }
      })
    },
    // 接口字段缺失时给默认值，itemNo 统一为字符串以匹配 radio 的 label="1/2"
    norm (item) {
      item = item || {}
      return {
        ...item,
        itemNo: String(item.itemNo || '2'),
        showName: item.showName || ''
      }
    },
    saveFnS () {
      this.$refs.addFormS.validate((valid) => {
        if (!valid) return
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        // 直接取三组对象拼 updateList，保留各自原有字段（id 等），仅规整 itemNo/showName
        const updateList = [
          this.build(this.addFormS.creditDateReminder),
          this.build(this.addFormS.creditLimitReminder),
          this.build(this.addFormS.repaymentDateReminder)
        ]
        updateWarningReminderSet({ updateList }).then(res => {
          loading.close()
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.getDetail()
        }).catch(error => {
          loading.close()
          this.$message({
            showClose: true,
            message: error.message || '操作失败',
            type: 'error'
          })
        })
      })
    },
    // 组装更新项：保留原对象字段，关闭时 showName 置空
    build (item) {
      return {
        ...item,
        itemNo: item.itemNo,
        showName: item.itemNo === '1' ? String(item.showName || '') : ''
      }
    }
  }
}
</script>

<style scoped lang="less">
.searchBtnBox {
  margin-left: 10px;
}
.addinpBox .el-input {
  width: 210px;
}
</style>
